
import {map, tap} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SecureHttp } from '../helpers/securehttp';
import { environment } from '../../environments/environment';

@Injectable()
export class ConfigService {

    private config: any;

    constructor(
        private http: HttpClient,
        private secureHttp: SecureHttp
    ) {
    }

    get CurrentConfig(): any {
        return localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config') || '{}') : null;
    }

    getConfig(refresh?: boolean): Observable<any> {
        if (this.config && !refresh) {
            return of(this.config);
        }
        return this.http.get(`${environment.apiUrl}api/config`).pipe(
            tap(response => localStorage.setItem('config', JSON.stringify(response))),
            map(response => {
                this.config = response;
                return this.config;
            }));
    }

    getAdminConfig(): Observable<any> {
        return this.http.get(`${environment.apiUrl}api/config/admin`)
            ;
    }

    getCurrentOutage(): Observable<any> {
        return this.http.get(`${environment.apiUrl}api/config/outages/current`)
            ;
    }

    getPlannedOutages(): Observable<any> {
        return this.http.get(`${environment.apiUrl}api/config/outages`)
            ;
    }

    savePlannedOutage(outage:any): Observable<any> {
        return (outage.Id ? this.http.put(`${environment.apiUrl}api/config/outages/${outage.Id}`, outage) : this.http.post(`${environment.apiUrl}api/config/outages`, outage))
            ;
    }

    deletePlannedOutage(outage:any): Observable<any> {
        return this.http.delete(`${environment.apiUrl}api/config/outages/${outage.Id}`);
    }

    runLoadTest(rate: number, duration: number): Observable<any> {
        let params = new HttpParams()
        params = params.set('rate', rate.toString())
        params = params.set('duration', duration.toString())
        return this.secureHttp.get(`${environment.apiUrl}api/test/compass-load`, { params: params });
    }
}
